export const WebUiMarketingCTAEnI18n = {
    section0: {
        btnCTA: {
            label: `<a data-link="ctaLink"></a>`,
        },
    },
    linkConfigs: [
        {
            key: `ctaLink`,
            commands: ['', { outlets: { modal: ['auth', 'signup'] } }],
            navExtras: {
                queryParams: {
                    redirectUrl: '/items',
                },
                state: { skipScroll: true },
            },
            text: `Get Started`,
        },
    ],
};
